import React, { useState } from 'react';
import { Button, Card, Modal, Space, Table, TablePaginationConfig } from 'antd';

import {
  DeleteOutlined,
  ExclamationCircleOutlined,
  FormOutlined,
  PaperClipOutlined,
  InfoCircleOutlined,
  SettingOutlined,
} from '@ant-design/icons';

import { DeviceType } from '@services/types';

import api from '@services/api';
import { useHistory } from 'react-router-dom';
import { Navigation } from '@constants/Navigation';
import DeleteDeviceTypeModal from '@layouts/admin/DeviceType/DeleteDeviceTypeModal';

const { Column } = Table;

const DeviceTypePage = () => {
  const [deviceTypes, setDeviceTypes] = React.useState<DeviceType[]>([]);
  const [deviceTypeToDelete, setDeviceTypeToDelete] = useState<DeviceType>();
  const [pagination, setPagination] = React.useState<TablePaginationConfig>({
    current: 1,
    pageSize: 10,
    showSizeChanger: true,
    total: deviceTypes.length,
  });

  const history = useHistory();

  React.useEffect(() => {
    api.administration.getDeviceTypes().then((data) => {
      setDeviceTypes(data);
    });
  }, []);

  const handleTableChange = React.useCallback((newPagination: TablePaginationConfig) => {
    setPagination(newPagination);
  }, []);

  return (
    <Card
      title="Device Types"
      extra={
        <Button type="primary" onClick={() => history.push(Navigation.CreateDeviceType)}>
          Add
        </Button>
      }
      bodyStyle={{ padding: 0 }}
    >
      <Table
        dataSource={deviceTypes}
        pagination={pagination}
        onChange={handleTableChange}
        rowKey={(record: DeviceType) => record.id}
      >
        <Column title="Hardware Id" dataIndex="hardwareId" key="hardwareId" />
        <Column title="Usage Id" dataIndex="usageId" key="usageId" />
        <Column title="Name" dataIndex="deviceName" key="deviceName" />
        <Column title="Scope" dataIndex="scope" key="scope" />
        <Column title="Rescue Name" dataIndex="rescueName" key="rescueName" />
        <Column
          title="Actions"
          key="action"
          render={(text, deviceType: DeviceType) => (
            <Space size="middle">
              <InfoCircleOutlined
                onClick={() => history.push(Navigation.DeviceTypeInfo.replace(':id', deviceType.id))}
              />
              {deviceType.etc?.enableStbAuth && (
                <PaperClipOutlined
                  onClick={() => history.push(Navigation.Certificates.replace(':id', deviceType.id))}
                />
              )}
              <FormOutlined onClick={() => history.push(Navigation.UpdateDeviceType.replace(':id', deviceType.id))} />
              <SettingOutlined
                onClick={() => history.push(Navigation.DeviceTypeSettings.replace(':id', deviceType.id))}
              />
              <DeleteOutlined onClick={() => setDeviceTypeToDelete(deviceType)} />
            </Space>
          )}
        />
      </Table>
      {deviceTypeToDelete && (
        <DeleteDeviceTypeModal
          setDeviceTypes={setDeviceTypes}
          deviceTypes={deviceTypes}
          deviceTypeToDelete={deviceTypeToDelete}
          visible={!!deviceTypeToDelete}
          onClose={() => {
            setDeviceTypeToDelete(undefined);
          }}
        />
      )}
    </Card>
  );
};

export default React.memo(DeviceTypePage);
